import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RoutePaths } from '../../../core/constants/route-paths';
import { Router } from '@angular/router';
import { LOCAL_LANG } from '../../../core/constants/constants';
import { DataLayerService } from '../../../core/services/data-layer.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, IonicModule, TranslateModule],
  templateUrl: './header-public.component.html',
  styleUrl: './header-public.component.scss',
})
export class HeaderPublicComponent implements OnChanges {
  @Input() langSelected!: string;

  constructor(
    private translate: TranslateService,
    private readonly _router: Router,
    private readonly _dataLayerService: DataLayerService
  ) {}

  ngOnChanges() {
    this.langSelected = localStorage.getItem(LOCAL_LANG) || 'es';
  }

  changeLanguage(event: CustomEvent) {
    const selectedLanguage = event.detail.value;
    this.langSelected = selectedLanguage;

    this._dataLayerService.pushEventClickButton(
      '',
      `change-language-${selectedLanguage}`,
      `header.${selectedLanguage}`,
      'header'
    );

    //this.translate.use(selectedLanguage);
    localStorage.setItem(LOCAL_LANG, selectedLanguage);
    window.location.reload();
  }

  async handleRedirect(): Promise<void> {
    await this._router.navigate([`${RoutePaths.login}`]);
  }
}
